import { API_PATHS } from "./apiPaths";
import { axiosInstance } from "./axiosSetup";

export const getUsers = async () => {
    return axiosInstance.get(API_PATHS.USERS_LIST);
};

export const createUser = (user) => {
    return axiosInstance.post(API_PATHS.CREATE_USER, user);
}

export const disableUser = (username) => {
    return axiosInstance.post(API_PATHS.DISABLE_USER, { email: username });
}

export const enableUser = (username) => {
    return axiosInstance.post(API_PATHS.ENABLE_USER, { email: username });
}

